import { createContext } from 'react';
import initialState from './initialState';
import { BasketState } from './interface';

const BasketContext = createContext<BasketState>(initialState);
BasketContext.displayName = 'BasketContext';

export default BasketContext;
